
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orders",
      function () {
        return require("private-next-pages/orders/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orders"])
      });
    }
  